import {
  algodClient,
  convertToDisplayValue,
  displayValueToTxnValue,
} from '../helpers';

import {
  AlgoStakeASAIDs,
  DeflyASAIDs,
  USDCASAIDs,
  BINANCE_NETWORK_OPTIONS,
  actiontype,
  PepeASAIDs,
  CoopASAIDs,
  GAlgoASAIDs,
  ZONEASAIDs,
  TxnFee,
  MetaASAIDs,
  BSC_CONTRACT_ABI,
  BinanceCurrencies,
} from '../../utils/constants';

import { toast } from 'react-toastify';
import {
  WalletOption,
  BlockChainEnum,
  BinanceHexNetwork,
  BNBNetworkMetadata,
} from '../../../context/AppContext/types';
import { Magic } from 'magic-sdk';
import { sendSuccessTransactionMPEvent } from '../mixPanelHelpers';
import { CurrencyEnum } from 'src/graphql/types';
import { AlgorandExtension } from '@magic-ext/algorand';

const nodeEnv = process.env.NEXT_PUBLIC_NODE_ENV;
export const getBalanceFromAddr = async (address: string) => {
  let isOptedIn = false;
  let isGALGOOptedIn = false;
  let isAlgoStakeOptedIn = false;
  let isDeflyOptedIn = false;
  let isPepeOptedIn = false;
  let isUSDCOptedIn = false;
  let isCoopOptedIn = false;
  let isMetaOptedIn = false;
  let gAlgoBalance = 0;
  let balanceZone = 0;
  let algoStkBalance = 0;
  let deflyBalance = 0;
  let pepeBalance = 0;
  let USDCBalance = 0;
  let CoopBalance = 0;
  let MetaBalance = 0;

  const accountInfo = await algodClient().accountInformation(address).do();
  const minAlgoBalance =
    convertToDisplayValue(accountInfo['min-balance'] || 0) + TxnFee;
  const algostakeASA =
    nodeEnv === 'production'
      ? AlgoStakeASAIDs.MAINNET
      : AlgoStakeASAIDs.TESTNET;
  const deflyASA =
    nodeEnv === 'production' ? DeflyASAIDs.MAINNET : DeflyASAIDs.TESTNET;
  const pepeASA =
    nodeEnv === 'production' ? PepeASAIDs.MAINNET : PepeASAIDs.TESTNET;
  const USDCASA =
    nodeEnv === 'production' ? USDCASAIDs.MAINNET : USDCASAIDs.TESTNET;
  const COOPASA =
    nodeEnv === 'production' ? CoopASAIDs.MAINNET : CoopASAIDs.TESTNET;
  const METAASA =
    nodeEnv === 'production' ? MetaASAIDs.MAINNET : MetaASAIDs.TESTNET;

  accountInfo.assets.forEach((asset: any) => {
    if (
      (asset['asset-id'] || '').toString() === process.env.NEXT_PUBLIC_ASA_ID
    ) {
      isOptedIn = true;
      balanceZone = convertToDisplayValue(asset.amount) || 0;
    }
    if (
      (asset['asset-id'] || '').toString() ===
      process.env.NEXT_PUBLIC_FOLKS_FINANCE_ASA_ID
    ) {
      isGALGOOptedIn = true;
      gAlgoBalance = convertToDisplayValue(asset.amount) || 0;
    }
    if ((asset['asset-id'] || '').toString() === algostakeASA.toString()) {
      isAlgoStakeOptedIn = true;
      algoStkBalance = convertToDisplayValue(asset.amount) || 0;
    }
    if ((asset['asset-id'] || '').toString() === deflyASA.toString()) {
      isDeflyOptedIn = true;
      deflyBalance = convertToDisplayValue(asset.amount) || 0;
    }
    if ((asset['asset-id'] || '').toString() === pepeASA.toString()) {
      isPepeOptedIn = true;
      pepeBalance = convertToDisplayValue(asset.amount, 4) || 0;
    }
    if ((asset['asset-id'] || '').toString() === USDCASA.toString()) {
      isUSDCOptedIn = true;
      USDCBalance = convertToDisplayValue(asset.amount) || 0;
    }
    if ((asset['asset-id'] || '').toString() === COOPASA.toString()) {
      isCoopOptedIn = true;
      CoopBalance = convertToDisplayValue(asset.amount) || 0;
    }
    if ((asset['asset-id'] || '').toString() === METAASA.toString()) {
      isMetaOptedIn = true;
      MetaBalance = convertToDisplayValue(asset.amount) || 0;
    }
  });

  const balanceAlgo = convertToDisplayValue(accountInfo.amount);
  return {
    balanceZone,
    balanceAlgo,
    isOptedIn,
    gAlgoBalance,
    isGALGOOptedIn,
    isAlgoStakeOptedIn,
    isDeflyOptedIn,
    isCoopOptedIn,
    isMetaOptedIn,
    isPepeOptedIn,
    algoStkBalance,
    deflyBalance,
    pepeBalance,
    isUSDCOptedIn,
    USDCBalance,
    CoopBalance,
    MetaBalance,
    minAlgoBalance,
  };
};
export const getContract = (provider: any, type: any) => {
  if (!provider || !type) return;
  const Contract = new provider.eth.Contract(
    BSC_CONTRACT_ABI,
    // @ts-ignore:next-line
    BinanceCurrencies?.[type]?.contractAddress,
  );
  return Contract;
};
export const fetchBNBBalance = async (address: string, provider: any) => {
  if (window?.navigator?.onLine) {
    try {
      const Web3 = (await import('web3')).default;
      const web3 = new Web3(provider);

      const USDCContract = getContract(web3, CurrencyEnum.USDC);
      const DOGEContract = getContract(web3, CurrencyEnum.DOGE);
      const FLOKIContract = getContract(web3, CurrencyEnum.FLOKI);
      const BTCBContract = getContract(web3, CurrencyEnum.BTCB);
      const ETHContract = getContract(web3, CurrencyEnum.ETH);
      const BUSDContract = getContract(web3, CurrencyEnum.BUSD);
      const USDTContract = getContract(web3, CurrencyEnum.USDT);
      let USDCBalance = await USDCContract.methods.balanceOf(address).call();
      let DOGEBalance = await DOGEContract.methods.balanceOf(address).call();
      let FLOKIBalance = await FLOKIContract.methods.balanceOf(address).call();
      let BTCBBalance = await BTCBContract.methods.balanceOf(address).call();
      let ETHBalance = await ETHContract.methods.balanceOf(address).call();
      let BUSDBalance = await BUSDContract.methods.balanceOf(address).call();
      let USDTBalance = await USDTContract.methods.balanceOf(address).call();
      let bnbBalance: any = await web3.eth.getBalance(address); // Get wallet balance
      let isOptedIn: boolean = false;
      bnbBalance =
        Math.round(parseFloat(web3.utils.fromWei(bnbBalance) || '0') * 100000) /
        100000;
      USDCBalance =
        Math.round(
          parseFloat(web3.utils.fromWei(USDCBalance) || '0') * 100000,
        ) / 100000;
      ETHBalance = convertToDisplayValue(
        ETHBalance,
        BinanceCurrencies[CurrencyEnum.ETH]?.decimal,
      );
      DOGEBalance = convertToDisplayValue(
        DOGEBalance,
        BinanceCurrencies[CurrencyEnum.DOGE]?.decimal,
      );
      FLOKIBalance = convertToDisplayValue(
        FLOKIBalance,
        BinanceCurrencies[CurrencyEnum.FLOKI]?.decimal,
      );
      BUSDBalance = convertToDisplayValue(
        BUSDBalance,
        BinanceCurrencies[CurrencyEnum.BUSD]?.decimal,
      );
      USDTBalance = convertToDisplayValue(
        USDTBalance,
        BinanceCurrencies[CurrencyEnum.USDT]?.decimal,
      );

      BTCBBalance = convertToDisplayValue(
        BTCBBalance,
        BinanceCurrencies[CurrencyEnum.BTCB]?.decimal,
      );

      return {
        bnbBalance,
        USDCBalance,
        DOGEBalance,
        FLOKIBalance,
        BTCBBalance,
        ETHBalance,
        BUSDBalance,
        USDTBalance,
        isOptedIn,
      };
    } catch (err) {
      console.info('balance fetch error', err);
      toast.error('Failed to fetch wallet balance');
    }
  }
};
export const handleMetamaskChainSwitch = async (provider: any, chain: any) => {
  try {
    await provider?.switchChain({ id: chain?.id });
  } catch (switchError: any) {
    console.log('switcherrCode', switchError?.code);
    if (switchError?.code === 4902 || switchError?.code === -32000) {
      try {
        await provider?.addChain({
          chain,
        });
      } catch (addError) {
        console.log('err in add chain', addError);
      }
    } else {
      console.log('err in network switch', switchError);
    }
  }
};
export const switchEthereumChain = async (provider: any) => {
  const networkIndex: string = process.env.NEXT_PUBLIC_NODE_ENV || '';
  const chainId: number = BinanceHexNetwork[networkIndex];
  try {
    await provider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId }],
    });
  } catch (switchError: any) {
    console.log('err in network switch', switchError);
    if (switchError.code === 4902) {
      try {
        await provider.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              ...BNBNetworkMetadata[networkIndex],
            },
          ],
        });
      } catch (addError) {
        toast.error('Failed to add new chain in Metamask wallet');
        console.log('err in add chain', addError);
        return addError;
      }
    }
  }
};
function getBytes(value: string): Uint8Array {
  if (typeof value === 'string' && value.match(/^0x([0-9a-f][0-9a-f])*$/i)) {
    const result = new Uint8Array((value.length - 2) / 2);
    let offset = 2;
    for (let i = 0; i < result.length; i++) {
      result[i] = parseInt(value.substring(offset, offset + 2), 16);
      offset += 2;
    }
    return result;
  }
  throw new Error('invalid bytes');
}
async function parseTransaction(encodedTransaction: string) {
  const data = getBytes(encodedTransaction);
  const RLP = (await import('rlp')).default;
  const fields = RLP.decode(data) as Uint8Array[];
  const fieldsInHex = fields.map((field: Uint8Array) => {
    return '0x' + Buffer.from(field).toString('hex');
  });
  const toBigInt = (value: string) => {
    if (value === '0x') {
      return BigInt(0);
    }
    return BigInt(value);
  };
  const tx = {
    nonce: Number(toBigInt(fieldsInHex[0])),
    to: fieldsInHex[3],
    value: Number(toBigInt(fieldsInHex[4])),
    data: fieldsInHex[5],
  };
  return tx;
}
export const transferBinanceCurrency = async (
  provider: any,
  amount: number,
  from: any,
  to: any,
  unsignedTransaction: any,
  currency: any,
) => {
  const type = localStorage.getItem('walletManagerType');
  // const web3 = new Web3(provider);
  const Web3 = (await import('web3')).default;
  const web3 = new Web3(provider);
  const Contract = await getContract(web3, currency);
  const amountToSend = web3.utils.toWei(amount.toString(), 'ether'); // Replace with the amount of curreny you want to send
  Contract.methods.transfer(to, amountToSend);
  let gasPrice: any = 1000000;
  if (!to) {
    to = from;
  }
  await web3.eth.getGasPrice((error: Error, price: string) => {
    if (error) {
      console.error('Error while tranferring: ', error);
    }
    gasPrice = price;
  });
  const txData = await parseTransaction(unsignedTransaction);
  // Build the transaction data
  const rawTransaction = {
    from,
    gasPrice: Number(gasPrice),
    ...txData,
  };
  return web3.eth
    .sendTransaction(rawTransaction)
    .then(function (receipt) {
      let signedTransaction = receipt.transactionHash;
      if (signedTransaction) {
        sendSuccessTransactionMPEvent(
          signedTransaction,
          from,
          to,
          amount,
          type,
        );
      }
      return { txId: signedTransaction, connectedWallet: type };
    })
    .catch(err => {
      console.log('error in send txn', err);
      return { txId: null, connectedWallet: type };
    });
};
export const transferBNB = async (
  metamaskProvider: any,
  amount: number,
  from: string,
  //note: string,
  to?: string,
  data?: string,
) => {
  const type = localStorage.getItem('walletManagerType');
  // const web3 = new Web3(metamaskProvider);
  const Web3 = (await import('web3')).default;
  const web3 = new Web3(metamaskProvider);
  let gasPrice: any = 1000000;
  if (!to) {
    to = from;
  }
  await web3.eth.getGasPrice((error: Error, price: string) => {
    if (error) {
      console.error('Error while tranferring BNBs: ', error);
    }
    gasPrice = price;
  });
  const convertToHex = (str: string) => {
    var hex = '';
    for (var i = 0; i < str.length; i++) {
      hex += '' + str.charCodeAt(i).toString(16);
    }
    return hex;
  };
  return web3.eth
    .sendTransaction({
      from,
      to,
      gasPrice: Number(gasPrice),
      value: web3.utils.toWei(amount.toString()),
      //note: note
      data: data ? convertToHex(data) : undefined,
    })
    .then(function (receipt) {
      let signedTransaction = receipt.transactionHash;
      if (signedTransaction) {
        sendSuccessTransactionMPEvent(
          signedTransaction,
          from,
          to,
          amount,
          type,
        );
      }
      return { txId: signedTransaction, connectedWallet: type };
    })
    .catch(err => {
      console.log('error in send txn', err);
      return { txId: null, connectedWallet: type };
    });
};

// To be enabled along with MetaMask,BSC and Magic Wallet
export const signWalletTransaction = async (
  provider: any,
  walletAddress: any,
  message: string,
  type?: string | undefined,
) => {
  try {
    let signature;
    const wagmiConnected = localStorage.getItem('wagmi.connected');
    if (wagmiConnected) {
      const signMessage = (await import('@wagmi/core')).signMessage;
      signature = await signMessage({
        message,
      });
    } else {
      // const web3 = new Web3(provider);
      const Web3 = (await import('web3')).default;
      const web3 = new Web3(provider);
      signature = await web3.eth.personal
        .sign(message, walletAddress, '')
        .then((sign: any) => {
          return sign;
        });
    }
    const txId = Buffer.from(
      JSON.stringify({
        message,
        signature,
      }),
    ).toString('base64');
    return {
      txId,
      connectedWallet:
        type === 'MagicBnB'
          ? WalletOption.MAGIC
          : type === 'BSC'
          ? WalletOption.BSC
          : type === 'TRUST'
          ? WalletOption.TRUST
          : WalletOption.METAMASK,
      chain: BlockChainEnum.BINANCE,
    };
  } catch (err: any) {
    console.error(err);
    toast.error('Signature generation failed');
  }
};
export const createMagicInstance = (chain?: any) => {
  let options: any = {
    extensions: {
      algorand: new AlgorandExtension({
        rpcUrl: '', // should remain empty
      }),
    },
  };
  if (chain === 'BINANCE') {
    options = {
      network:
        nodeEnv === 'production'
          ? {
              ...BINANCE_NETWORK_OPTIONS?.mainNet,
            }
          : {
              ...BINANCE_NETWORK_OPTIONS?.testNet,
            },
    };
  }
  return (
    typeof window !== 'undefined' &&
    new Magic(
      process.env.NEXT_PUBLIC_MAGIC_PUBLISHABLE_KEY ||
        'pk_live_E70ABC3912A3D1F9',
      options,
    )
  );
};

export const getMagicBnBWeb3Provider = async (magicInstance?: any) => {
  const magic = magicInstance || createMagicInstance('BINANCE');
  // @ts-ignore:next-line
  // const web3 = new Web3(magic.rpcProvider);
  const Web3 = (await import('web3')).default;
  const web3 = new Web3(magic.rpcProvider);

  return web3;
};
const getAssetId = (type: any) => {
  switch (type) {
    case 'ZONE':
      return nodeEnv === 'production' ? ZONEASAIDs.MAINNET : ZONEASAIDs.TESTNET;
    case 'USDC':
      return nodeEnv === 'production' ? USDCASAIDs.MAINNET : USDCASAIDs.TESTNET;
    case 'PEPE':
      return nodeEnv === 'production' ? PepeASAIDs.MAINNET : PepeASAIDs.TESTNET;
    case 'GALGO':
      return nodeEnv === 'production'
        ? GAlgoASAIDs.MAINNET
        : GAlgoASAIDs.TESTNET;
    case 'STKE':
      return nodeEnv === 'production'
        ? AlgoStakeASAIDs.MAINNET
        : AlgoStakeASAIDs.TESTNET;
    case 'DEFLY':
      return nodeEnv === 'production'
        ? DeflyASAIDs.MAINNET
        : DeflyASAIDs.TESTNET;
    case 'COOP':
      return nodeEnv === 'production' ? CoopASAIDs.MAINNET : CoopASAIDs.TESTNET;
    case 'META':
      return nodeEnv === 'production' ? MetaASAIDs.MAINNET : MetaASAIDs.TESTNET;
    default:
      return '';
  }
};
export const transferAmount = async (
  chain: string | undefined,
  walletType: string | undefined,
  from: string,
  to: string,
  amount: any,
  currency: string,
  walletManager: any,
  dispatch: any,
) => {
  if (!from || !to || !amount) return;
  let transactionId;
  if (walletType === 'MAGIC' && chain === 'BINANCE') {
    const web3 = await getMagicBnBWeb3Provider();
    // Submit transaction to the blockchain and wait for it to be mined
    await web3.eth.sendTransaction({
      from,
      to,
      value: web3.utils.toWei(amount.toString()),
      maxFeePerGas: '3000000000',
      maxPriorityFeePerGas: '3000000000',
    } as any);
  } else {
    // @ts-ignore:next-line
    const magic = createMagicInstance();
    const algosdk = (await import('algosdk')).default;

    if (currency === 'ALGO') {
      transactionId = await walletManager.algoPaymentTransaction(
        from,
        displayValueToTxnValue(amount),
        'transfer',
        to,
        magic,
      );
      await algosdk.waitForConfirmation(algodClient(), transactionId.txId, 10);
      // await walletManager.waitForTransaction(transactionId.txId);
    } else {
      const assetId = getAssetId(currency);
      const challengeAmount =
        currency === 'PEPE'
          ? displayValueToTxnValue(amount, 4)
          : displayValueToTxnValue(amount);
      transactionId = await walletManager.assetTransfer(
        from,
        assetId,
        to,
        'transfer',
        challengeAmount,
        magic,
      );
      await algosdk.waitForConfirmation(algodClient(), transactionId, 10);
    }
    const {
      balanceZone,
      balanceAlgo,
      gAlgoBalance,
      algoStkBalance,
      deflyBalance,
      pepeBalance,
      USDCBalance,
      CoopBalance,
      MetaBalance,
    } = await getBalanceFromAddr(from);
    dispatch({
      type: actiontype.SET_WALLET_BALANCE,
      payload: {
        balanceZone,
        balanceAlgo,
        gAlgoBalance,
        algoStkBalance,
        deflyBalance,
        pepeBalance,
        USDCBalance,
        CoopBalance,
        MetaBalance,
      },
    });
  }
};
export const convertBnBTxnValueToDisplayValue = async (value: any) => {
  const web3 = await getMagicBnBWeb3Provider();
  return parseFloat(web3.utils.fromWei(value) || '0');
};

export const handleChangeWallet = (dispatch: any) => {
  dispatch({ type: actiontype.CLEAR_WALLET });
  if (typeof window !== 'undefined') {
    localStorage.removeItem('walletconnect');
    localStorage.removeItem('token');
    localStorage.removeItem('walletManagerType');
    localStorage.removeItem('walletAddress');
    window.location.reload();
  }
};
export const initializeEthProvider = async (
  showQrModal: any = false,
  chains: any = [1],
) => {
  const EthereumProvider = (await import('@walletconnect/ethereum-provider'))
    .EthereumProvider;
  return await EthereumProvider.init({
    projectId: 'e4a1e343eb711c425e91e26133ad3fe8',
    showQrModal,
    chains,
    methods: ['eth_sendTransaction', 'personal_sign', 'eth_chainId'],
    events: ['chainChanged', 'accountsChanged', 'connect'],
    qrModalOptions: {
      enableExplorer: false,
      explorerRecommendedWalletIds: [
        'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
        '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4',
        '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0',
      ],
      explorerExcludedWalletIds: 'ALL',
    },
  });
};
